import { useSelectedChart } from "@/contexts/ChartsContext";
import { Colors } from "@/enums/Colors";
import { MainDashBoardChart } from "@/enums/MainDashBoardChart";
import StringUtils from "@/external/ensolvers-core-frontend-mui-v5/submodules/fox-typescript/utils/StringUtils";
import { MonthlyChartDTO } from "@/models/charts/MonthlySpendingChartDTO";
import { Box, BoxProps } from "@mui/material";
import { BarElement, CategoryScale, Chart as ChartJS, ChartOptions, Legend, LinearScale, Title, Tooltip } from "chart.js";
import React from "react";
import { Bar } from "react-chartjs-2";
import { AskAIButtonProps, ChartTopBar } from "./ChartTopBar";

ChartJS.register(CategoryScale, LinearScale, BarElement, Title, Tooltip, Legend);

interface Props {
  data: MonthlyChartDTO;
  containerProps?: BoxProps;
}

interface PropsToHandleInChat {
  refer?: React.RefObject<ChartJS>;
  chartOptions?: ChartOptions;
}

const BarColor = Colors.LAZO_PURPLE;

const options: ChartOptions = {
  responsive: true,
  plugins: {
    legend: {
      display: false,
    },
    title: {},
    tooltip: {
      backgroundColor: "white",
      borderColor: "grey",
      borderWidth: 0.5,
      padding: 8,
      bodyColor: Colors.LIGHT_GRAY_8A8E93,
      titleColor: Colors.LIGHT_GRAY_8A8E93,
      boxWidth: 10,
      boxHeight: 10,
      titleMarginBottom: 16,
    },
  },
  elements: {
    bar: { borderRadius: 2, backgroundColor: BarColor },
  },
  maintainAspectRatio: false,
  scales: {
    x: {
      grid: {
        display: false,
      },
      border: {
        display: false,
      },
    },
    y: {
      display: false,
      border: {
        display: false,
      },
    },
  },
};

const KEY = "CURRENT";
export const SpendingChart = ({
  data,
  disableAskAIButton,
  containerProps,
  refer,
  chartOptions,
}: Props & AskAIButtonProps & PropsToHandleInChat) => {
  const { setSelectedChart } = useSelectedChart();

  const mapData = (chartDto: MonthlyChartDTO): any => {
    const labels = chartDto.keys.map((l) => l.slice(0, 3));
    let values = chartDto.data.map((d) => d.values[KEY]).filter((value) => typeof value === "number");

    let datasets = [
      {
        type: "bar",
        label: StringUtils.toTitleCase(KEY),
        data: values,
        barThickness: 24,
        borderRadius: 2,
      },
    ];

    return { labels, datasets };
  };

  return (
    <Box sx={{ width: "100%", height: "90%" }} {...containerProps}>
      <ChartTopBar
        disableAskAIButton={disableAskAIButton}
        onStarIconClick={() => setSelectedChart(MainDashBoardChart.SPENDING)}
        keys={[]}
        title="Spending"
      />
      <Bar
        style={{ paddingTop: "5px", height: "100%" }}
        data={data.data.length > 0 ? mapData(data) : defaultData}
        options={{ ...(options as any), ...chartOptions }}
        ref={refer as any}
      />
    </Box>
  );
};

const defaultData = {
  labels: ["a", "b", "c", "d", "e", "f"],
  datasets: [
    {
      label: "Data",
      data: [10, 0, 0, 0, 0, 0, 40],
      borderWidth: 1,
    },
  ],
};
